import { Connection, Transaction, Signer, TransactionInstruction, ComputeBudgetProgram } from '@solana/web3.js';
import { WalletContextState } from '@solana/wallet-adapter-react';

export async function sendTx(
  connection: Connection,
  wallet: Pick<WalletContextState, 'publicKey' | 'signTransaction'>,
  instructions: TransactionInstruction[],
  signers: Signer[] = []
) {
  const tx = new Transaction().add(...instructions);
  tx.feePayer = wallet.publicKey!;
const latestBlockhash = await connection.getLatestBlockhash()
  tx.recentBlockhash = latestBlockhash.blockhash;
  const addPriorityFee = ComputeBudgetProgram.setComputeUnitPrice({
    microLamports: 3330000,
  });
  const withPriorityFee = tx.add(addPriorityFee)

  if (signers && signers.length > 0) {
    withPriorityFee.sign(...signers)
  }

  const signed = await wallet.signTransaction!(withPriorityFee);

  //const latestBlockhash = await connection.getLatestBlockhash();
  //await connection.simulateTransaction(signed)
  const txId = await connection.sendRawTransaction(signed.serialize());
  await connection.confirmTransaction({
    signature: txId,
    blockhash: latestBlockhash.blockhash,
    lastValidBlockHeight: latestBlockhash.lastValidBlockHeight
  }, "confirmed");
  return txId;
}

